import React, { useEffect } from 'react'
import { object, func, node, array, oneOfType, bool } from 'prop-types'
import { Formik, Form as FormikForm, useFormikContext } from 'formik'

export const useFormContext = useFormikContext

export const Form = ({
  initialValues,
  validate,
  onSubmit,
  enableReinitialize,
  children,
  ...rest
}) => (
  <Formik
    enableReinitialize={enableReinitialize}
    initialValues={initialValues}
    validate={validate}
    onSubmit={onSubmit}
    {...rest}
  >
    <FormikForm>{children}</FormikForm>
  </Formik>
)

Form.propTypes = {
  initialValues: object.isRequired,
  validate: func,
  onSubmit: func.isRequired,
  children: oneOfType([node, array]),
  enableReinitialize: bool,
}

export const FormErrorHandler = ({ errors }) => {
  const { setErrors } = useFormContext()

  useEffect(() => {
    if (errors) {
      setErrors(errors)
    }
  }, [errors, setErrors])

  return null
}

FormErrorHandler.propTypes = {
  errors: object,
}
